import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";

import styles from "./TandCView.module.css";

export default function TandCView() {
  return (
    <>
      <Navbar />
      <div>
        <div className={styles.termsContainer}>
          <h1>Terms and Conditions</h1>
          <div className={styles.section}>
            <h2>1. Introduction</h2>
            <p>
              Welcome to FirstLand, the forefront of revolutionizing the real
              estate industry through the power of artificial intelligence (AI)
              and technology. Founded in 2022 by Dvir Cohen, FirstLand, Inc
              emerged with a clear mission: to simplify and enhance the
              experience of buying, selling, and renting properties for all
              parties involved.
              {/* At the heart of our innovation lies a commitment
              to leveraging AI to streamline the real estate process, making it
              faster, more efficient, and ultimately more enjoyable. */}
            </p>
            <p>
              Our platform is designed to support clients at every step of their
              real estate journey. For buyers, we offer a personalized search
              experience tailored to their preferences, ensuring they find their
              ideal property with ease. Sellers benefit from our Landlord
              dashboard and marketing tools that highlight their property's best
              features, while renters enjoy a hassle-free process facilitated by
              our intuitive platform. Additionally, real estate agents are
              equipped with advanced tools to close deals more effectively, data
              analysis and lead generation.
            </p>
            <p>
              By accessing and using the FirstLand website, you acknowledge and
              agree to be bound by our terms and conditions. These terms govern
              your use of our website and services, setting forth the rights and
              responsibilities that are critical for ensuring a safe, reliable,
              and respectful environment for all users. We invite you to join us
              on this exciting journey into the future of real estate, where
              technology and AI open new possibilities for everyone involved in
              the property market.
            </p>
          </div>
          <div className={styles.section}>
            <h2>2. Definitions</h2>
            <ul>
              <li>
                <strong>FirstLand:</strong> Refers to the tech real estate
                company founded by Dvir Cohen in 2022, leveraging artificial
                intelligence to enhance the real estate buying, selling, and
                renting process.
              </li>
              <li>
                <strong>Real Estate Process:</strong> Encompasses all activities
                related to the buying, selling, and renting of real estate
                properties, including but not limited to property search,
                listing, marketing, transaction handling, and customer service.
              </li>
              <li>
                <strong>Artificial Intelligence (AI):</strong> A branch of
                computer science dedicated to creating systems that can perform
                tasks, which typically require human intelligence. In the
                context of FirstLand, AI is planned to be used to analyze data,
                optimize listings, and provide personalized services to clients.
              </li>
              <li>
                <strong>Machine Learning:</strong> A subset of AI that involves
                the development of algorithms that allow computers to learn and
                make decisions based on data. FirstLand uses machine learning to
                analyze real estate trends and buyer/seller behavior.
              </li>
              <li>
                <strong>Natural Language Processing (NLP):</strong> A field of
                AI that focuses on the interaction between computers and humans
                through natural language. FirstLand utilizes NLP in its
                AI-powered chatbots to interact with clients and provide them
                with relevant information.
              </li>
              {/* <li>
                <strong>AI-powered Platform:</strong> Refers to FirstLand's
                online platform that integrates artificial intelligence
                technologies to facilitate various aspects of the real estate
                process.
              </li> */}
              {/* <li>
                <strong>Personalized Search Experience:</strong> A feature of
                FirstLand's platform that uses AI to tailor property search
                results according to the individual preferences and priorities
                of buyers.
              </li> */}
              {/* <li>
                <strong>Listing Optimizer:</strong> An AI tool provided by
                FirstLand that analyzes market data to create compelling
                property descriptions aimed at attracting potential buyers.
              </li> */}
              <li>
                <strong>AI-powered Chatbot:</strong> A conversational agent
                developed by FirstLand that utilizes natural language processing
                to assist clients with inquiries, property information, and
                scheduling showings. Currently, under testing version.
              </li>
              <li>
                <strong>Real Estate Agents:</strong> Professionals who
                facilitate buying, selling, and renting of properties however
                without a valid real estate license verified by FirstLand’s back
                office. FirstLand provides these agents with AI tools to enhance
                their efficiency and effectiveness.
              </li>
              <li>
                <strong>Marketing Tools:</strong> A range of digital tools and
                technologies provided by FirstLand to help sellers and real
                estate agents promote properties more effectively.
              </li>
            </ul>
          </div>
          <div className={styles.section}>
            <h2>3. Conditions for Account Creation and User Requirements</h2>
            <p>
              Users must be 18 years of age or older to create an account on
              FirstLand. By creating an account, users affirm that they meet the
              age requirement. In addition, you have not previously been
              suspended or removed from the Services; and (c) your registration
              and your use of the Services complies with all applicable laws and
              regulations. To access some features of the Services, you may be
              required to register for an account and agree to a Product’s
              Terms, to the extent applicable to that service. When you register
              for an account, you will be asked to provide us with some
              information about yourself, such as email address, phone number,
              or other contact information. You agree that the information you
              provide is accurate and that you will keep it accurate and up to
              date at all times. When you register, you will be asked to provide
              a password. You are solely responsible for maintaining the
              confidentiality of your account and password, and you are
              responsible for all actions taken via your account. You may not
              share your user account(s) with others. Unless you have entered
              into a commercial agreement with us permitting you to use the
              Services for transactions on behalf of another person, you may use
              the Services only for transactions on your own behalf.
            </p>
            <p>
              <strong>Account Information:</strong> Users must provide accurate
              and complete information during the account registration process,
              including a valid email address and contact information. It is the
              user's responsibility to keep this information up to date.
            </p>
            <p>
              <strong>Account Security:</strong> Users are responsible for
              maintaining the confidentiality of their account password and are
              advised to choose a strong, unique password for their account. It
              is recommended that users change their password regularly and
              avoid sharing it with others.
            </p>
            <p>
              <strong>Acceptable Use: </strong> Users agree to use FirstLand's
              platform and services for lawful purposes only and in a manner
              that does not infringe upon the rights of, or restrict or inhibit
              the use and enjoyment of the service by, any third party. This
              includes conduct that is harmful, threatening, abusive, harassing,
              defamatory, vulgar, obscene, or otherwise objectionable.
            </p>
            <p>
              <strong>Compliance with Laws: </strong> Users agree to comply with
              all local, state, national, and international laws and regulations
              applicable to their use of FirstLand’s services.
            </p>
            <p>
              <strong>Activity Under Account: </strong> Users are solely
              responsible for all activities that occur under their account,
              whether authorized by them or not. Users should immediately notify
              FirstLand of any unauthorized use of their account or any other
              breach of security.
            </p>
            <p>
              <strong>Content Ownership and Permission: </strong> When posting
              content to FirstLand, users affirm they have the right to use and
              share this content. This includes property listings, photos, and
              any personal information shared on the platform.
            </p>
            <p>
              <strong>Interactions with Other Users: </strong> Users are
              responsible for their interactions with other users on FirstLand's
              platform. While FirstLand may provide tools to facilitate these
              interactions, it is not liable for the conduct of any user on or
              off the platform.
            </p>
            <p>
              <strong>Data Privacy and Protection: </strong> Users should review
              FirstLand’s Privacy Policy to understand how their personal
              information is collected, used, and shared. Users are responsible
              for safeguarding their personal information and should be cautious
              about sharing sensitive information with others on the platform.
            </p>
            <p>
              <strong>Termination and Suspension of Account: </strong> FirstLand
              reserves the right to suspend or terminate a user’s account if
              they are found to be in violation of the terms and conditions,
              including providing false account information, engaging in
              prohibited activities, or failing to maintain account security.
            </p>
            <p>
              By creating an account and using the services offered by
              FirstLand, users acknowledge they have read, understood, and
              agreed to adhere to these conditions, requirements, and
              responsibilities. FirstLand is committed to providing a secure,
              efficient, and user-friendly platform to enhance the real estate
              buying, selling, and renting experience through the power of AI
              technology.
            </p>
            <h2>3.a. License Verification for Real Estate Professionals</h2>
            <p>
              FirstLand requires all users representing themselves as licensed
              real estate professionals—including Realtors, Brokers, and
              Agents—to submit valid, verifiable license information and
              documentation as part of the account registration or onboarding
              process.
            </p>
            <p>
              Users agree that any license information provided is accurate,
              current, and compliant with applicable state and local licensing
              requirements. FirstLand reserves the right to verify, validate,
              and audit submitted license data and supporting documents.
            </p>
            <p>
              Accounts found to contain false, fraudulent, expired, or
              unverifiable license information may be suspended, restricted, or
              terminated at FirstLand’s sole discretion. Continued use of the
              platform as a licensed professional is contingent upon maintaining
              valid license status and passing all verification checks.
            </p>
            <p>
              FirstLand disclaims any liability arising from user
              misrepresentation of professional licenses and encourages users
              and clients to exercise due diligence when engaging with
              professionals on the platform.
            </p>
            <h2>3.b Age Verification</h2>
            <p>
              FirstLand requires users to be at least 18 years old to create an
              account. By using our platform, you affirm that you meet this age
              requirement. We reserve the right to verify your age at any time
              and may suspend or terminate accounts if we suspect a user is
              underage.
            </p>
            <p>
              Compliance with age requirements ensures adherence to applicable
              laws, including the Children’s Online Privacy Protection Act
              (COPPA) and other regulations protecting minors.
            </p>
          </div>
          <div className={styles.section}>
            <h2>4. Use of the Website</h2>
            <p>
              FirstLand's website is designed to serve as a comprehensive
              platform for buyers, sellers, and renters in the real estate
              market, as well as real estate agents looking for a more efficient
              way to conduct their business. The website utilizes advanced AI
              technologies, including machine learning and natural language
              processing, to offer personalized search experiences, optimized
              property listings, and efficient market analysis.
            </p>
            {/* <p>
              For Buyers: To search for and find properties that match their
              specific preferences and needs, leveraging AI to filter through
              thousands of listings efficiently.
            </p>
            <p>
              For Sellers: To list properties and utilize AI-powered marketing
              tools for optimizing listings based on data analysis of past
              sales, market trends, and buyer behaviors.
            </p>
            <p>
              For Renters: To discover rental properties that meet their
              criteria, interact with AI-powered chatbots for information and
              scheduling showings.
            </p>
            <p>
              For Real Estate Agents: To access a suite of tools designed to
              analyze buyer and seller data, identify leads, and suggest
              personalized marketing strategies, ultimately helping them close
              deals more efficiently.
            </p> */}
          </div>
          <div className={styles.section}>
            <h2>5. Permissible and Prohibited Behaviors on the Website</h2>
            <p>
              <strong>Permissible Behaviors: </strong>
            </p>
            <ul>
              <li>
                <p>Searching for properties based on individual preferences.</p>
              </li>
              <li>
                <p>Listing properties for sale or rent.</p>
              </li>
              <li>
                <p>
                  Utilizing the platform's AI features for market analysis and
                  optimization of listings.FirstLand’s AI outputs are for
                  informational purposes and do not constitute professional
                  advice; users assume all risk.
                </p>
              </li>
              <li>
                <p>
                  Engaging with chatbots and other AI tools for information and
                  assistance.
                </p>
              </li>
            </ul>
            <p>
              <strong>
                Copyrights, Trademarks, and Ownership of Material on the Website{" "}
              </strong>
            </p>
            <p>
              All content present on the FirstLand website, including text,
              graphics, logos, images, as well as the underlying technology and
              software, is owned by FirstLand or its licensors and is protected
              by copyright, trademark, patent, trade secret, and other
              intellectual property or proprietary rights laws. "FirstLand" and
              its associated logos and designs are trademarks of FirstLand and
              may not be used without the explicit written permission of
              FirstLand.
            </p>
            <p>
              <strong>
                Restrictions on the Use of Website Content Outside the Site{" "}
              </strong>
            </p>
            <p>
              Content from the FirstLand website may not be copied, reproduced,
              republished, uploaded, posted, transmitted, distributed, or used
              for the creation of derivative works without FirstLand's prior
              written consent, except that FirstLand grants you non-exclusive,
              non-transferable, limited permission to access and display the web
              pages within this site, solely on your computer and for your
              personal, non-commercial use of this website. This permission is
              conditional upon your not modifying the content displayed on this
              site, your keeping intact all copyright, trademark, and other
              proprietary notices, and your acceptance of any terms, conditions,
              and notices accompanying the content or otherwise set forth in
              this site. Any unauthorized use terminates the permission or
              license granted by FirstLand.
            </p>
          </div>
          <div className={styles.section}>
            <h2>6. User-Generated Content Policy</h2>
            <p>
              At FirstLand, we understand and value the importance of community
              engagement and the significant role that User-Generated Content
              (UGC) plays on our platform. UGC refers to any content—be it text,
              reviews, comments, photos, videos, or any other media—that our
              users create and post on our platform. This content is invaluable
              in enriching the FirstLand experience, offering insights, personal
              experiences, and feedback that help users make informed decisions
              in the real estate process.
            </p>
            <p>
              <strong>
                Policies Regarding Content Posted or Created by Users{" "}
              </strong>
            </p>
            <p>
              Content Ownership: Users retain ownership of the content they post
              on FirstLand, but grant FirstLand a non-exclusive, royalty-free,
              perpetual, and worldwide license to use, reproduce, display,
              perform, adapt, modify, distribute, have distributed, and promote
              such content in any form, in all media now known or hereinafter
              created, anywhere in the world, for any purpose.
            </p>
            <p>
              <strong>Content Standards </strong>
            </p>
            <p>
              All user-generated content must comply with our community
              guidelines, which prohibit offensive, defamatory, obscene, or
              otherwise objectionable or illegal material. Users are responsible
              for ensuring that their content does not infringe upon the
              intellectual property rights of others or violate any local,
              state, national, or international laws.
            </p>
            <p>
              <strong>Moderation and Removal </strong>
            </p>
            <p>
              FirstLand reserves the right, but is not obligated, to monitor and
              edit or remove any UGC that we determine in our sole discretion
              violates these policies or is otherwise harmful to our community.
              While we value open expression, we also aim to maintain a
              respectful and safe environment for all our users.
            </p>
            <p>
              <strong>Accuracy of Content</strong>
            </p>
            <p>
              Users posting content are responsible for the accuracy and
              truthfulness of their submissions. FirstLand does not verify,
              endorse, or otherwise vouch for the accuracy of user-generated
              content and disclaims all liability related thereto.
            </p>
            <p>
              <strong>Rights You Have Over User-Generated Content </strong>
            </p>
            <p>
              Editing and Deletion: Users have the right to edit or delete their
              own content at any time. Should you wish to remove your content
              from our platform, you can do so through your account settings or
              by contacting our support team.
            </p>
            <p>
              Reporting Infringements: If you believe that any content on
              FirstLand infringes upon your intellectual property rights or
              violates our content policies, please report this to us
              immediately. We are committed to responding to such concerns
              promptly and taking appropriate action, which may include removing
              the infringing content or disabling access to it.
            </p>
            <p>
              At FirstLand, we are dedicated to leveraging the power of AI to
              revolutionize the real estate industry. Our platform's embrace of
              User-Generated Content is a testament to our belief in the power
              of community collaboration and shared knowledge. We encourage our
              users to contribute positively and responsibly, ensuring that
              FirstLand remains a trusted and valuable resource for everyone
              involved in the real estate process.
            </p>
          </div>
          <div className={styles.section}>
            <h2>7. User Privacy Policy of FirstLand </h2>
            <p>
              At FirstLand, the integrity and security of our clients' data
              stand at the core of our operations. Our commitment to privacy is
              unwavering, as we recognize the significance of protecting the
              personal and sensitive information entrusted to us by our users.
              Our User Privacy Policy is designed to transparently communicate
              how we collect, use, protect, and share information within our
              AI-powered real estate platform.
            </p>
            <p>
              <strong>Information Collection </strong>
            </p>
            <p>
              FirstLand collects user information in various ways, including but
              not limited to, user registrations, property inquiries, and
              interactions with our AI-powered tools. The types of information
              collected may include personal identification information (name,
              email, phone number), property preferences, search criteria, and
              any communication exchanged through our platform. We also collect
              technical data such as usage details, IP addresses, and cookies to
              enhance user experience and improve our services.
            </p>
            <p>
              <strong>Use of Information </strong>
            </p>
            <p>
              The information collected by FirstLand serves multiple purposes:
            </p>
            <ul>
              <li>
                <p>
                  To personalize the user experience on our platform, ensuring
                  that property recommendations and insights are tailored to
                  individual preferences and needs.
                </p>
              </li>
              <li>
                <p>
                  To facilitate communication between buyers, sellers, renters,
                  and real estate agents, enhancing the efficiency of
                  transactions and inquiries.
                </p>
              </li>
              <li>
                <p>
                  To improve our platform and services by analyzing usage
                  patterns, market trends, and user feedback.
                </p>
              </li>
              <li>
                <p>
                  To provide customer support and resolve any issues or
                  inquiries related to our services.
                </p>
              </li>
              <li>
                <p>Data Protection </p>
              </li>
            </ul>
            <p>
              FirstLand employs advanced security measures to protect the data
              we collect. This includes encryption, secure server hosting, and
              access controls designed to prevent unauthorized access,
              disclosure, alteration, or destruction of personal information.
              Our AI technologies are developed with privacy in mind, ensuring
              that all data processing adheres to the highest standards of
              confidentiality and integrity.
            </p>
            <p>
              <strong>Information Sharing </strong>
            </p>
            <p>
              We do not sell, trade, or rent users' personal identification
              information to others. We may share generic aggregated demographic
              information not linked to any personal identification information
              regarding visitors and users with our business partners, trusted
              affiliates, and advertisers for the purposes outlined above. We
              may use third-party service providers to help us operate our
              business and the Site or administer activities on our behalf, such
              as sending out newsletters or surveys. We may share your
              information with these third parties for those limited purposes
              provided that you have given us your permission.
            </p>
            <p>
              <strong>User Rights</strong>
            </p>
            <p>
              Users of FirstLand have rights concerning their personal data,
              including the right to access, correct, or delete their personal
              information stored by us. Our platform provides mechanisms for
              users to exercise these rights, ensuring transparency and control
              over their data.
            </p>
            <p>
              <strong>Changes to the Privacy Policy </strong>
            </p>
            <p>
              FirstLand reserves the right to update this privacy policy at any
              time. When we do, we will revise the updated date at the bottom of
              this page. We encourage Users to frequently check this page for
              any changes to stay informed about how we are helping to protect
              the personal information we collect. You acknowledge and agree
              that it is your responsibility to review this privacy policy
              periodically and become aware of modifications.
            </p>
            <p>
              <strong>Contacting Us </strong>
            </p>
            <p>
              If you have any questions about this Privacy Policy, the practices
              of this site, or your dealings with this site, please contact us
              at Team@Firstland.Homes.
            </p>
            <h3>Data Retention and Deletion</h3>
            <p>
              FirstLand retains personal data, including billing information,
              only as long as necessary to fulfill the purposes outlined in this
              Privacy Policy, comply with legal obligations, resolve disputes,
              and enforce agreements.
            </p>
            <p>
              Users may request access to, correction of, deletion of, or export
              of their personal data in compliance with applicable data
              protection laws such as GDPR and CCPA. Requests can be submitted
              by contacting us at{" "}
              <a href="mailto:Team@Firstland.Homes">Team@Firstland.Homes</a>.
            </p>
            <p>
              We will respond to such requests in accordance with applicable law
              and may require identity verification to process requests.
            </p>
          </div>
          <div className={styles.section}>
            <h2>8. Privacy Policy: Data Collection, Use, and Protection </h2>
            <p>
              At FirstLand, we are committed to safeguarding the privacy and
              security of our users' data. Our platform employs cutting-edge
              artificial intelligence (AI) technologies to enhance the real
              estate buying, selling, and renting experience. This section
              outlines how we collect, use, and protect your data to provide
              these services.
            </p>
            <p>
              <strong>Data Collection</strong>
            </p>
            <p>
              1. Information You Provide: We collect information that you
              voluntarily provide when using our services, including but not
              limited to your name, email address, phone number, and
              preferences. This information is essential for personalizing your
              experience on our platform, from property searches to
              transactions.
            </p>
            <p>
              2. Automated Data Collection: Our AI-powered platform
              automatically collects data as you interact with our services.
              This includes user behavior data, such as pages visited, search
              queries, and interaction metrics. We also collect technical data
              like IP addresses, browser types, and operating system details to
              ensure our platform's compatibility and security.
            </p>
            <p>
              3. Third-Party Data: We may receive additional information about
              you from third-party sources, including public databases and
              marketing partners. This information is integrated with the data
              you provide to enhance the accuracy and personalization of our
              services.
            </p>
            <p>
              <strong>Data Use</strong>
            </p>
            <p>We use the collected data to:</p>
            <ul>
              <li>
                <p>
                  Personalize Your Experience: Tailor property search results
                  and recommendations based on your preferences and previous
                  interactions.
                </p>
              </li>
              <li>
                <p>
                  Improve Our Services: Utilize AI algorithms to analyze data
                  patterns, optimize platform performance, and introduce new
                  features that address user needs.
                </p>
              </li>
              <li>
                <p>
                  To improve our platform and services by analyzing usage
                  patterns, market trends, and user feedback.
                </p>
              </li>
              <li>
                <p>
                  Communicate: Send you updates, promotional offers, and
                  important information related to your transactions and
                  account.
                </p>
              </li>
              <li>
                <p>
                  Market Analysis: Perform market trend analysis to provide
                  valuable insights to buyers, sellers, and real estate agents.
                </p>
              </li>
              <li>
                <p>
                  Security: Ensure the integrity and security of our platform,
                  detect fraud, and enforce our terms and conditions.
                </p>
              </li>
              <li>
                <p>Data Protection</p>
              </li>
              <li>
                <p>
                  Protecting your personal information is our top priority. We
                  implement robust security measures, including encryption,
                  firewalls, and secure socket layer (SSL) technology, to
                  protect your data from unauthorized access, alteration, or
                  disclosure. Additionally, we adhere to strict data privacy
                  regulations and conduct regular audits to ensure compliance
                  and address potential vulnerabilities.
                </p>
              </li>
            </ul>
            <p>
              Data Sharing: We do not sell, rent, or trade your personal
              information with third parties for their marketing purposes
              without your explicit consent. Data may be shared with trusted
              partners who work on our behalf under confidentiality agreements,
              such as property managers or real estate agents, solely to enhance
              the services offered to you. Any data shared is limited to what is
              necessary for the completion of those services.
            </p>
            <p>
              User Rights: You have the right to access, correct, or delete your
              personal information stored on our platform. If you wish to
              exercise these rights or have concerns about your data's privacy
              and security, please contact us at Team@Firstland.Homes.
            </p>
            <p>
              This Privacy Policy is subject to change to reflect new features
              or changes in our privacy practices. We will notify you of any
              significant changes and obtain your consent where required by law.
            </p>
            <h3>
              {" "}
              Key Privacy Policy Points to Include Related to Stripe Billing{" "}
            </h3>
            <p>
              FirstLand uses Stripe, a trusted third-party payment processor, to
              securely handle all billing transactions related to subscriptions,
              premium listings, and other paid services. When you provide
              payment information, such as credit or debit card details, this
              data is transmitted directly to Stripe and is not stored on our
              servers. We collect necessary billing information including your
              name, email address, billing address, phone number, payment method
              details, transaction history, subscription plans, and usage data
              related to billing such as subscription status, invoices, and
              refunds.
            </p>
            <p>
              The information we collect is used to process payments securely
              and accurately, to manage subscriptions, billing cycles, renewals,
              and cancellations, and to communicate billing-related updates,
              invoices, or any payment issues you may encounter. We do not sell
              or rent your payment information to any third parties.
            </p>
            <p>
              Payment processing is conducted via Stripe and possibly other
              payment processors. You can review Stripe’s privacy practices and
              security standards by visiting their privacy policy at{" "}
              <a
                href="https://stripe.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://stripe.com/privacy
              </a>
              . We may disclose your data to law enforcement or regulatory
              authorities if required by law.
            </p>
            <p>
              We implement reasonable administrative, technical, and physical
              safeguards to protect your personal and billing information from
              unauthorized access or disclosure, including encryption, secure
              servers, and strict access controls. Stripe complies with PCI-DSS
              standards to ensure secure payment processing. Nevertheless, no
              method of transmission over the internet or electronic storage is
              completely secure.
            </p>
            <p>
              You have the right to access, correct, or delete your personal
              data related to billing. To exercise these rights or if you have
              any questions about your billing data, please contact us at
              Team@Firstland.Homes.
            </p>
            <p>
              Our billing pages and website may use cookies or other tracking
              technologies for payment processing and fraud prevention purposes.
            </p>
            <h3>Cookie Notice</h3>
            <p>
              Our site uses cookies and similar technologies to enhance your
              experience, analyze traffic, and serve personalized content and
              ads. On your first visit, you will be prompted to consent to
              cookies as required by applicable laws. You may adjust your cookie
              preferences at any time via the Cookie Settings. We use cookies,
              web beacons, and similar tracking technologies (collectively,
              “cookies”) to provide and improve our services, analyze trends,
              and prevent fraud. Cookies help us remember your preferences,
              measure the effectiveness of our content, and personalize your
              experience.
            </p>
            <p>
              By continuing to use our site, you consent to the placement of
              cookies on your device as described in our{" "}
              <p>
                You can disable certain cookies through your browser settings,
                but please note that turning off essential cookies may prevent
                you from using some features of the site.
              </p>
              <p>
                If you are located within the European Economic Area (EEA) or
                the United Kingdom, you will be presented with a consent banner
                on your first visit, and you may manage your cookie preferences
                via that banner or by visiting our Cookie Settings.
              </p>
            </p>
            <p>
              You can disable certain cookies through your browser settings, but
              please note that turning off essential cookies may prevent you
              from using some features of the site.
            </p>
            <p>
              We retain billing data for as long as necessary to fulfill
              accounting, tax, and legal obligations.
            </p>
            <div className={styles.section}>
              <h2>Cookies &amp; Tracking</h2>
              <p>
                We use cookies, web beacons, and similar technologies
                (collectively, “cookies”) to operate our site, analyze traffic,
                personalize your experience, and provide certain features.
              </p>

              <h3>1. Types of Cookies We Use</h3>
              <ul>
                <li>
                  <strong>Essential Cookies:</strong> Required for core site
                  functionality (e.g. login, security, form submissions).
                </li>
                <li>
                  <strong>Analytics Cookies:</strong> Help us understand how
                  visitors interact with FirstLand (e.g. pageviews, click
                  paths). We use Google Analytics.
                </li>
                <li>
                  <strong>Marketing Cookies:</strong> Track your activity across
                  sites to deliver more relevant ads or measure ad campaign
                  performance.
                </li>
                <li>
                  <strong>Preference Cookies:</strong> Remember your preferences
                  (e.g. language, region).
                </li>
              </ul>

              <h3>2. Consent &amp; Control</h3>
              <p>
                On your first visit, you’ll see a banner allowing you to “Accept
                All Cookies” or select which categories you permit. You can
                change your preferences at any time via the “Cookie Settings”
                link in our footer.
              </p>
              <p>
                To disable cookies, you can also adjust your browser settings.
                Note that blocking essential cookies may prevent key features of
                our site from working.
              </p>

              <h3>3. Third‑Party Cookies</h3>
              <p>
                We allow third parties—such as Google and Facebook—to place
                cookies on your device for analytics and advertising. Those
                third parties’ privacy policies govern their use and collection
                of data.
              </p>

              <h3>4. More Information</h3>
              <p>
                For full details on each cookie we set, how long they persist,
                and how to opt out, see the table below:
              </p>

              <div className={styles.tableWrapper}>
                <table className={styles.cookieTable}>
                  <thead>
                    <tr>
                      <th>Cookie Name</th>
                      <th>Purpose</th>
                      <th>Expires In</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>_ga</td>
                      <td>Google Analytics client identifier</td>
                      <td>2 years</td>
                    </tr>
                    <tr>
                      <td>_gid</td>
                      <td>Google Analytics session identifier</td>
                      <td>24 hours</td>
                    </tr>
                    <tr>
                      <td>fr</td>
                      <td>Facebook ad targeting</td>
                      <td>3 months</td>
                    </tr>
                    {/* …add your other cookies here… */}
                  </tbody>
                </table>
              </div>

              <p>
                If you have questions about our use of cookies or wish to delete
                cookies we set, please contact us at{" "}
                <a href="mailto:Team@Firstland.Homes">Team@Firstland.Homes</a>.
              </p>
            </div>
          </div>
          <div className={styles.section}>
            <h2>9. Limitation of Liability </h2>
            <ul>
              <p>
                To the maximum extent permitted by law, FirstLand, including its
                founders, employees, agents, partners, and affiliates, shall not
                be liable for any direct, indirect, incidental, special,
                consequential, or punitive damages resulting from your access to
                or use of, or inability to access or use, the platform and its
                services. This includes, without limitation, damages for loss of
                profits, data, use, goodwill, or other intangible losses, even
                if FirstLand has been advised of the possibility of such
                damages.
              </p>
              <p>
                FirstLand shall not be liable for any damages or losses
                resulting from:
              </p>
              <p>1. The accuracy, completeness, or content of the site.</p>
              <p>
                2. Any unauthorized access to or use of our secure servers
                and/or any personal information stored therein.
              </p>
              <p>
                3. Any interruption or cessation of transmission to or from the
                site.
              </p>
              <p>
                4. Any bugs, viruses, trojan horses, or the like which may be
                transmitted to or through our platform by any third party.
              </p>
              <p>
                5. Any errors or omissions in any content or for any loss or
                damage incurred as a result of the use of any content posted,
                emailed, transmitted, or otherwise made available through
                FirstLand.
              </p>
              <p>
                Furthermore, FirstLand does not warrant, endorse, guarantee, or
                assume responsibility for any product or service advertised or
                offered by a third party through the FirstLand platform or any
                hyperlinked website or service, and FirstLand will not be a
                party to or in any way monitor any transaction between you and
                third-party providers of products or services.
              </p>
              <p>
                <strong>Disclaimer</strong>
              </p>
              <p>
                FirstLand provides its platform and services on an "as is" and
                "as available" basis. FirstLand and its founders, employees,
                agents, partners, and affiliates hereby disclaim all warranties
                of any kind, whether express or implied, including, but not
                limited to, the implied warranties of merchantability, fitness
                for a particular purpose, non-infringement, and any other
                warranty that might arise under any law. Without limiting the
                foregoing, FirstLand makes no representations or warranties:
              </p>
              <p>
                1. That the platform, any of the services or any features
                therein will be made available on an uninterrupted, secure, or
                error-free basis.
              </p>
              <p>
                2. Regarding the accuracy, reliability, or currency of any
                information, content, service, or merchandise provided through
                the platform.
              </p>
              <p>
                3. That the platform, its servers, the content, or e-mails sent
                from or on behalf of FirstLand are free of viruses, scripts,
                trojan horses, worms, malware, timebombs or other harmful
                components.
              </p>
              <p>
                Some jurisdictions do not allow the exclusion of certain
                warranties or the limitation or exclusion of liability for
                incidental or consequential damages. Accordingly, some of the
                above limitations may not apply to you.
              </p>
            </ul>
          </div>
          <div className={styles.section}>
            <h2>10. Indemnification </h2>
            <ul>
              <p>
                You ("the User") agree to defend, indemnify, and hold harmless
                FirstLand, its affiliates, licensors, and service providers, and
                its and their respective officers, directors, employees,
                contractors, agents, licensors, suppliers, successors, and
                assigns from and against any claims, liabilities, damages,
                judgments, awards, losses, costs, expenses, or fees (including
                reasonable attorneys' fees) arising out of or relating to your
                violation of these Terms and Conditions or your use of the
                FirstLand platform, including, but not limited to:
              </p>
              <ul>
                <ul>
                  <p>
                    • Your Misuse of the Platform: Any unauthorized or improper
                    use of the FirstLand website or services, including any use
                    contrary to FirstLand's intended purpose and guidelines, or
                    any use that contravenes applicable laws and regulations.
                  </p>
                  <p>
                    • User-Generated Content: The creation, posting, sharing, or
                    dissemination of content on or through the FirstLand
                    platform that infringes on intellectual property rights,
                    violates privacy rights, or is otherwise unlawful.
                  </p>
                  <p>
                    • Dealings with Other Users: Your interactions or
                    transactions with other users of the FirstLand platform,
                    including disputes and negotiations related to buying,
                    selling, or renting properties.
                  </p>
                  <p>
                    • Violation of Laws and Rights: Any activity on your part
                    that violates any applicable law or regulation or infringes
                    upon the rights of any third party while using the FirstLand
                    services.
                  </p>
                  <p>
                    • Misrepresentation: Providing inaccurate, false, or
                    misleading information during the account creation process,
                    property listing, or any other use of the platform.
                  </p>
                  <p>
                    • This indemnification obligation will survive the
                    termination or expiration of these Terms and Conditions and
                    your use of the FirstLand platform.
                  </p>
                </ul>
              </ul>
              <p>
                Disclaimer: It is essential for FirstLand to ensure that users
                understand their responsibilities and the scope of their actions
                on the platform. The indemnification clause serves as a
                protective measure against potential legal challenges and
                reinforces the importance of using the website responsibly.
              </p>
              <p>
                By incorporating such a detailed indemnification requirement
                into your Terms and Conditions, FirstLand can mitigate legal
                risks and focus on providing a transformative real estate
                experience through AI and technology. However, it's highly
                recommended to consult with a legal professional when drafting
                your Terms and Conditions to ensure they are comprehensive,
                comply with all relevant laws and regulations, and accurately
                reflect your business operations and goals.
              </p>
            </ul>
          </div>
          <div className={styles.section}>
            <h2>11. Intellectual Property Rights </h2>
            <ul>
              <p>
                <strong>Ownership of Intellectual Property:</strong>
              </p>
              <p>
                All content published and made available on our website,
                including, but not limited to, text, logos, icons, images,
                software, videos, and graphics, is the property of FirstLand and
                is protected under international copyright laws. Our ownership
                of such content does not transfer to you or any other user of
                our site.
              </p>
              <p>
                The technology and software underlying our platform and the
                services provided are the property of FirstLand, Dvir Cohen, our
                affiliates, and our partners. We grant you a limited,
                non-exclusive, revocable license to use our platform for your
                personal use in accordance with these terms.
              </p>
              <p>
                The use of our AI technology, including but not limited to
                machine learning algorithms, natural language processing tools,
                listing optimizers, and any other AI-powered features, is
                subject to the terms of this agreement. These technologies are
                integral parts of our proprietary services offered through
                FirstLand and constitute significant intellectual property owned
                by FirstLand.
              </p>
              <p>
                <strong>Trademarks: </strong>
              </p>
              <p>
                The trademarks, logos, and service marks ("Marks") displayed on
                our website are the property of FirstLand and other third
                parties. You are not permitted to use these Marks without the
                prior written consent of FirstLand or the third party that owns
                the Marks.
              </p>
              <p>
                <strong>
                  Copyright and Intellectual Property Infringements:{" "}
                </strong>
              </p>
              <p>
                We respect the intellectual property rights of others and expect
                our users to do the same. It is our policy to respond to any
                claim that content posted on our platform infringes on the
                copyright or other intellectual property rights ("Infringement")
                of any person or entity.
              </p>
              <p>
                If you are a copyright owner, or authorized on behalf of one,
                and believe that any content on our website constitutes
                Infringement of your work, please report this by submitting a
                notice to us including the following information:
              </p>
              <li>
                <p>
                  A physical or electronic signature of the copyright owner or a
                  person authorized to act on their behalf.
                </p>
              </li>
              <li>
                <p>
                  Identification of the copyrighted work claimed to have been
                  infringed.
                </p>
              </li>
              <li>
                <p>
                  Identification of the material that is claimed to be
                  infringing or to be the subject of infringing activity and
                  that is to be removed or access to which is to be disabled,
                  along with information reasonably sufficient to permit us to
                  locate the material.
                </p>
              </li>
              <li>
                <p>
                  Your contact information, including your address, telephone
                  number, and an email address.
                </p>
              </li>
              <li>
                <p>
                  A statement by you that you have a good faith belief that use
                  of the material in the manner complained of is not authorized
                  by the copyright owner, its agent, or the law.
                </p>
              </li>
              <li>
                <p>
                  A statement that the information in the notification is
                  accurate, and under penalty of perjury, that you are
                  authorized to act on behalf of the owner of an exclusive right
                  that is allegedly infringed.
                </p>
              </li>
              <p>
                Please send your notice of Infringement to us via email at
                Team@Firstland.Homes.
              </p>
              <p>
                Upon receiving a proper Infringement notice, FirstLand will take
                appropriate actions under the applicable intellectual property
                laws to remove or disable access to the infringing material and
                notify the content provider or user that it has removed or
                disabled access to the material.
              </p>
              <p>
                Information on how users should report copyright or intellectual
                property infringements.
              </p>
            </ul>
          </div>
          <div className={styles.section}>
            <h2>12. Changes to the Terms and Conditions </h2>
            <ul>
              <p>
                FirstLand reserves the exclusive right to update, modify, or
                otherwise alter these Terms and Conditions at any time. Such
                changes are integral to our commitment to innovation, ensuring
                that our services, including the utilization of artificial
                intelligence and technology in real estate, remain at the
                forefront of industry standards and legal requirements. Our aim
                is to continuously improve your experience and the efficacy of
                our platform, adapting to new advancements in technology,
                changes in the real estate market, and evolving legal
                landscapes.
              </p>
              <p>
                <strong>Notification of Changes </strong>
              </p>
              <p>
                Acceptance of Changes: Continued use of the FirstLand platform
                after the effective date of such changes will constitute your
                acceptance of the updated Terms and Conditions. If you do not
                agree to the changes, you retain the right to discontinue using
                our services. We encourage you to review the Terms and
                Conditions periodically to stay informed of any updates.
              </p>
              <p>
                Accessibility: The most current version of the Terms and
                Conditions will always be accessible on our website. We will
                maintain an archive of previous versions for your reference,
                which can be requested by contacting our support team.
              </p>
              <p>
                Urgent Changes: In rare circumstances, changes may be made
                immediately without advance notice, due to legal requirements or
                other urgent factors. In such cases, we will notify users as
                soon as practicably possible.
              </p>
              <p>
                By engaging with FirstLand, you acknowledge and agree that it is
                your responsibility to stay informed about our Terms and
                Conditions, including any amendments. Your continued use of our
                services following any changes signifies your acceptance of
                those changes.
              </p>
              <p>
                I. Advance Notice: We will provide reasonable advance notice of
                any significant changes to these Terms and Conditions. This
                notice will be communicated through one or more of the following
                channels, at our discretion:
              </p>
              <li>
                <p>A prominent announcement on the FirstLand website.</p>
              </li>
              <li>
                <p>
                  Direct notification within the FirstLand platform interface.
                </p>
              </li>
              <li>
                <p>
                  Review Period: Whenever possible, we will offer a grace period
                  from the time of the notification until the effective date of
                  the changes. This period allows you to review the
                  modifications and decide if you agree to the updated terms.
                </p>
              </li>
              <p></p>
            </ul>
          </div>
          <div className={styles.section}>
            <h2>13. Governing Law and Jurisdiction </h2>
            <p>
              <strong>Governing Law </strong>
            </p>
            <p>
              The Terms and Conditions (the "Terms") described herein are
              governed by and construed in accordance with the laws of the State
              of Florida, United States of America, without regard to its
              conflict of law provisions. By accessing or using the FirstLand
              platform, you agree that the statutes and laws of the State of
              Florida will apply to all matters relating to the use of this
              website and the services offered herein.
            </p>
            <p>
              <string> Jurisdiction</string>
            </p>
            <p>
              You hereby irrevocably consent to the exclusive jurisdiction and
              venue of the state and federal courts in Miami-Dade County,
              Florida, USA, in all disputes arising out of or relating to the
              use of the FirstLand platform or under these Terms. In the event
              of any dispute or claim associated with these Terms or the use of
              any services provided by FirstLand, the parties agree to submit to
              the personal and exclusive jurisdiction of these courts.
            </p>
            <p>
              Notwithstanding the foregoing, FirstLand reserves the right to
              bring any suit, action, or proceeding against you for breach of
              these Terms in your country of residence or any other relevant
              country. FirstLand may seek injunctive relief in any court of
              competent jurisdiction to prevent the actual or threatened
              infringement, misappropriation, or violation of our data security,
              intellectual property rights, or other proprietary rights.
            </p>
            <p>
              <strong> Dispute Resolution</strong>
            </p>
            <p>
              Before filing any claim against FirstLand, you agree to first
              attempt to negotiate any dispute informally by contacting
              FirstLand directly. We will attempt to resolve the dispute
              informally by contacting you via email. If a dispute is not
              resolved within a period of thirty (30) days from the time
              informal dispute resolution is pursued pursuant to this paragraph,
              then either party may bring a formal proceeding.
            </p>
            <p>
              You agree that any cause of action or claim you may have arising
              out of or related to these Terms or your use of the FirstLand
              platform must be filed within one (1) year after such claim or
              cause of action arose, or be forever barred.
            </p>
            <div className={styles.section}>
              <h2>14. Arbitration Agreement</h2>
              <p>
                To expedite resolution and reduce the costs of disputes, you and
                FirstLand agree that any dispute, claim, or controversy arising
                out of or relating to these Terms, your use of the platform, or
                services shall be resolved exclusively by binding arbitration,
                except that either party may seek injunctive or other equitable
                relief in a court of competent jurisdiction to prevent actual or
                threatened infringement, misappropriation, or violation of
                intellectual property rights.
              </p>
              <p>
                The arbitration shall be conducted by the American Arbitration
                Association (AAA) under its Consumer Arbitration Rules, or
                another mutually agreed-upon arbitration service. The
                arbitration will be held in Miami-Dade County, Florida, unless
                otherwise agreed.
              </p>
              <p>
                Both parties waive any right to a jury trial or to participate
                in a class action or representative proceeding.
              </p>
              <p>
                This arbitration clause shall survive termination of these Terms
                and Conditions.
              </p>
            </div>
          </div>
          <div className={styles.section}>
            <h2>15. Miscellaneous </h2>
            <p>
              <strong>Severability</strong>
            </p>
            <p>
              If any provision of these Terms and Conditions is found by a court
              of competent jurisdiction to be invalid, illegal, or
              unenforceable, such finding will not affect the remainder of these
              Terms, which will remain in full force and effect. Instead, the
              invalid, illegal, or unenforceable provision shall be modified by
              the court and interpreted so as to best accomplish the original
              provision's objectives within the limits of applicable law or
              applicable court decisions.
            </p>
            <p>
              <strong>Waiver</strong>
            </p>
            <p>
              The failure of FirstLand to exercise or enforce any right or
              provision of these Terms and Conditions shall not constitute a
              waiver of such right or provision. Any waiver of any provision of
              these Terms and Conditions will be effective only if in writing
              and signed by FirstLand. A waiver by FirstLand of any default will
              not constitute a waiver of any subsequent default.
            </p>
            <p>
              <strong>Complete Agreement</strong>
            </p>
            <p>
              These Terms and Conditions, together with any documents expressly
              referred to within them, constitute the entire agreement between
              you and FirstLand regarding your use of the website and supersede
              all prior agreements and understandings, whether written or oral,
              relating to its subject matter. No representation, statement,
              inducement, whether oral or written, not contained herein shall
              bind any party to this agreement.
            </p>
            <p>
              <strong>Amendment</strong>
            </p>
            <p>
              FirstLand reserves the right, at its sole discretion, to modify or
              replace these Terms at any time. If a revision is material, we
              will provide at least 30 days' notice prior to any new terms
              taking effect. What constitutes a material change will be
              determined at our sole discretion. By continuing to access or use
              our services after those revisions become effective, you agree to
              be bound by the revised terms. If you do not agree to the new
              terms, you are no longer authorized to use the services.
            </p>
            <p>
              <strong>Governing Law</strong>
            </p>
            <p>
              <strong>Contact Information</strong>
            </p>
            <p>
              For any questions about these Terms and Conditions, please contact
              us at Team@FirstLand.Homes
            </p>
          </div>
          <div className={styles.section}>
            <h2>16. Termination and Conditions </h2>
            <p>
              <strong>Termination by FirstLand: </strong>
            </p>
            <p>
              FirstLand reserves the right to terminate or suspend access to our
              platform and services at any time, without prior notice or
              liability, for any reason whatsoever, including, but not limited
              to, a breach of the Terms and Conditions. Reasons for termination
              may include:
            </p>
            <p>
              a. Unauthorized Use: Any use of the platform that is illegal or
              not expressly authorized by our Terms and Conditions.
            </p>
            <p>
              b. Abuse of Services: Actions that misuse our services or attempt
              to exploit our AI-driven functionalities beyond their intended
              use.
            </p>
            <p>
              c. Payment Issues: Failure to fulfill payment obligations for any
              premium or subscription-based services offered by FirstLand, if
              applicable.
            </p>
            <p>
              d. Data Privacy Violations: Compromising the privacy and security
              of other users' data or infringing on intellectual property
              rights.
            </p>
            <p>
              e. Inactivity: We may terminate accounts that are inactive for an
              extended period (e.g., over a year), ensuring the efficiency and
              security of our platform.
            </p>
            <p>
              <strong> Termination by Users: </strong>
            </p>
            <p>
              Users can terminate their agreement with FirstLand and discontinue
              the use of our services at any time by:
            </p>
            <p>
              a. Account Deletion: Utilizing the account deletion feature within
              user account settings, allowing for the removal of personal
              information and account data from our platform.
            </p>
            <p>
              b. Discontinuing Use: Ceasing all access and use of FirstLand's
              website and services. Users are advised that simply discontinuing
              use without account deletion may not remove stored personal data;
              therefore, formal account deletion is recommended for complete
              data removal.
            </p>
            <p>
              c. Notification: For users without an account or for any queries
              regarding termination, contacting FirstLand's support team for
              assistance in discontinuing the service use.
            </p>
            <p>
              <strong> Conditions Following Termination: </strong>
            </p>
            <p>
              Upon termination, all licenses and rights granted to you in these
              Terms and Conditions will immediately cease. FirstLand is not
              liable for any consequences, financial or otherwise, resulting
              from termination. It is the user's responsibility to secure any
              data or information prior to termination.
            </p>
            <p>
              Any provisions of the Terms and Conditions that, by their nature,
              should survive termination, shall survive termination, including,
              but not limited to, ownership provisions, warranty disclaimers,
              indemnity, and limitations of liability.
            </p>
          </div>
          <div className={styles.section}>
            <h2>17. Subscription and Payment Terms</h2>
            <p>
              FirstLand offers different membership types and subscription plans
              to accommodate various user needs in the real estate marketplace.
            </p>
            <h3>User Types</h3>
            <ul>
              <li>
                <strong>Regular Users:</strong> Individuals such as landlords or
                buyers who do not hold a real estate license and do not conduct
                real estate business professionally. Regular users receive free
                membership access to basic platform features.
              </li>
              <li>
                <strong>
                  Registered Real Estate Professionals (Non-Subscribers):
                </strong>{" "}
                Licensed professionals who have registered on FirstLand as pros
                but have not subscribed to any paid plan. They receive free
                membership with limited access.
              </li>
              <li>
                <strong>Subscribed Real Estate Professionals:</strong> Licensed
                professionals who have registered and purchased a paid
                subscription plan. These users enjoy full access to premium
                tools and features.
              </li>
            </ul>
            <h3>Subscription Plans for Real Estate Professionals</h3>
            <p>
              Subscribed real estate professionals are entitled to a free trial
              period of three (3) months upon initial subscription. During this
              trial, users may cancel their subscription at any time without
              charge.
            </p>
            <p>
              Following the trial period, subscriptions automatically convert to
              monthly paid plans at the stated rate. Monthly charges are billed
              in advance, and subscriptions continue on a month-to-month basis
              until canceled.
            </p>
            <p>
              Each user is eligible for one (1) free trial period only.
              Additional trial periods are not available for the same user
              account.
            </p>
            <p>
              Users may cancel their subscription at any time. Cancellation will
              take effect at the end of the current billing cycle, and no
              further charges will be applied. No refunds or credits will be
              issued for partial billing periods or unused time.
            </p>

            <h3>Premium Listings</h3>
            <p>
              Premium Listings are paid, monthly subscription-based listings
              available to all users, including regular and professional users.
              The current fee for Premium Listings is $10 per listing per month.
            </p>
            <p>
              Each Premium Listing is eligible for a one-time, seven (7) day
              free trial period. During the trial, the listing owner may cancel
              the Premium Listing without charge.
            </p>
            <p>
              If the Premium Listing is not canceled before the trial ends,
              monthly billing will commence automatically.
            </p>
            <p>
              If the Premium Listing is canceled after the trial period, the
              listing will retain Premium status until the end of the current
              30-day billing cycle. No refunds or credits will be provided for
              canceled Premium Listings during an active billing period.
            </p>
            <p>
              Users may only receive one (1) free trial per individual Premium
              Listing.
            </p>

            <h3>Payments and Billing</h3>
            <p>
              All payments for subscription plans and Premium Listings are
              processed securely through our third-party payment processor,
              Stripe. Users agree to provide accurate payment information and
              authorize FirstLand and Stripe to charge applicable fees according
              to the subscription and listing plans selected.
            </p>
            <p>
              Failure to provide payment or resolve payment issues may result in
              suspension or termination of access to paid features and Premium
              Listings.
            </p>
            <h3>Changes to Pricing and Plans</h3>
            <p>
              FirstLand reserves the right to modify subscription fees, Premium
              Listing charges, and plan features at any time. Users will be
              notified in advance of material changes, and continued use of paid
              services after such notice constitutes acceptance of the new
              terms.
            </p>
            <h3>Refund Policy</h3>
            <p>
              Except as explicitly provided herein (e.g., trial cancellations),
              all subscription and Premium Listing fees are non-refundable.
              Users are responsible for managing their subscriptions and
              cancellations in a timely manner.
            </p>
            <p>
              Refunds will only be issued where required by applicable consumer
              protection laws. Please review your local laws for any rights to
              refunds beyond those specified here.
            </p>
          </div>
          <div className={styles.section}>
            <h2>18. Accessibility Commitment</h2>
            <p>
              FirstLand is committed to ensuring digital accessibility for
              people with disabilities. We strive to comply with applicable laws
              such as the Americans with Disabilities Act (ADA) and WCAG
              standards to make our website and services accessible to all
              users.
            </p>
            <p>
              We continually work to improve the accessibility and usability of
              our platform. If you encounter any accessibility barriers or need
              assistance, please contact us at{" "}
              <a href="mailto:Team@Firstland.Homes">Team@Firstland.Homes</a> and
              we will make reasonable accommodations.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
